<template>
  <CdnList />
</template>

<script>
import CdnList from '@/components/cdn/CdnList.vue';

export default {
  components: {
    CdnList
  },
}
</script>

<style lang="scss" scoped></style>